import _ from 'lodash'
import { ViewerAppSpecData, CodePackage } from '@wix/thunderbolt-symbols'
import { BootstrapData } from '../../types'
import { BLOCKS_APPS_UTILS, BOOTSTRAP_DATA } from './moduleNames'

export interface IBlocksPreviewAppData {
	blocksPreviewData: {
		widgetsCodeMap: {
			[pageId: string]: {
				url: string
			}
		}
		widgetDescriptorsMap: { [widgetType: string]: object }
	}
}

interface IBlocksConsumerAppData {
	blocksConsumerData: {
		codeExperimentsQueryString: string
		codePackagesData: Array<CodePackage>
		invokePropsChangedOnUpdateConfig: boolean
	}
}

export interface IBlocksAppsUtils {
	createBlocksPreviewAppData(appData: ViewerAppSpecData): IBlocksPreviewAppData

	createBlocksConsumerAppData(appData: ViewerAppSpecData): IBlocksConsumerAppData

	isBlocksApp(appData: Pick<ViewerAppSpecData, 'appDefinitionId'>): boolean
}

export const BlocksAppsUtils = (bootstrapData: BootstrapData): IBlocksAppsUtils => {
	const EXPORT_UPDATE_CONFIG_WHITELIST = ['b278a256-2757-4f19-9313-c05c783bec92']
	const {
		wixCodeBootstrapData: { wixCodePageIds, codePackagesData },
		platformEnvData,
		blocksBootstrapData,
	} = bootstrapData

	if (platformEnvData.site.experiments['specs.thunderbolt.blocksAddStoresAppDefIdToUpdateConfigWhitelist']) {
		EXPORT_UPDATE_CONFIG_WHITELIST.push('a0c68605-c2e7-4c8d-9ea1-767f9770e087')
	}

	return {
		createBlocksPreviewAppData() {
			return {
				blocksPreviewData: {
					widgetsCodeMap: _.mapValues(wixCodePageIds, (url) => ({ url })),
					widgetDescriptorsMap: platformEnvData.blocks?.blocksPreviewData?.widgetDescriptorsMap ?? {},
				},
			}
		},
		createBlocksConsumerAppData({ appDefinitionId }) {
			const isBlocksInvokePropsChangedOnUpdateConfigEnabled = Boolean(platformEnvData.site.experiments['specs.thunderbolt.blocksInvokePropsChangedOnUpdateConfig'])
			const isInWhitelist = EXPORT_UPDATE_CONFIG_WHITELIST.includes(appDefinitionId)
			return {
				blocksConsumerData: {
					codeExperimentsQueryString: blocksBootstrapData.experimentsQueryParams,
					codePackagesData,
					invokePropsChangedOnUpdateConfig: isBlocksInvokePropsChangedOnUpdateConfigEnabled && isInWhitelist,
				},
			}
		},
		isBlocksApp({ appDefinitionId }) {
			return Boolean(blocksBootstrapData.blocksAppsData[appDefinitionId])
		},
	}
}

export default {
	factory: BlocksAppsUtils,
	deps: [BOOTSTRAP_DATA],
	name: BLOCKS_APPS_UTILS,
}
